export const getInitialFbReminderValues = date => ({
  type: 'FACEBOOK_REMINDER',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Send Facebook One Time Consent'
        }
      ],
      triggers: [
        {
          type: 'Comments On Post'
        },
        {
          type: 'Match Hashtag',
          value: []
        }
      ],
      platform: 'facebook',
      description: 'Send User Consent',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Opt FB User in'
        }
      ],
      triggers: [
        {
          type: 'Received One-Time Consent'
        }
      ],
      platform: 'facebook',
      description: 'User opt in',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Send Facebook Blast'
        }
      ],
      triggers: [
        {
          type: 'Send at specific time'
        }
      ],
      platform: 'facebook',
      description: 'Send Branded One Time Blast',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Opt FB User out'
        }
      ],
      triggers: [
        {
          type: 'Match Hashtag',
          value: ['#optout']
        }
      ],
      platform: 'facebook',
      description: 'User opt out',
      operator: 'all'
    }
  ],
  moderated: false,
  moderators: { handles: [] },
  automated: false,
  threshold: 20,
  enableFiltering: false,
  enableBlastFiltering: false,
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-reminder/create/container/initialValues.js